<template>
  <footer style="width:100%">
    <div class="container container-content">
      <div class="row container-body-footer">
        <div class="container container-footer">
          <div class="col text-center copyright-footer">
            <div class="footer-infos">
              <div class="text-left">
                <h6 class="title-info">À propos de nous</h6>
                <p class="text-info">
                  {{ restaurant.observation }}
                </p>
              </div>
              <div class="text-left">
                <h6 class="title-info">Contactez nous</h6>
                <ul class="list-infos">
                  <li class="item-info">
                    <a href="#" target="_blank" rel="noopener noreferrer"
                      ><span class="icon-info"><i class="fas fa-home"></i></span
                      ><span></span>{{ restaurant.address }}</a
                    >
                  </li>
                  <li class="item-info">
                    <a href="#" target="_blank" rel="noopener noreferrer"
                      ><span class="icon-info"
                        ><i class="fas fa-phone"></i></span
                      ><span></span>{{ restaurant.phone }}</a
                    >
                  </li>
                  <li class="item-info">
                    <a href="#" target="_blank" rel="noopener noreferrer"
                      ><span class="icon-info"
                        ><i class="fas fa-envelope"></i></span
                      ><span></span>{{ restaurant.email }}</a
                    >
                  </li>
                </ul>
              </div>
              <div class="text-left" v-if="restaurant.hours">
                <h6 class="title-info">Horaires</h6>
                <table id="hours">
                  <tr v-for="(hour, index) in restaurant.hours" :key="index">
                    <th :class="`${index == 0 ? 'colored-tr' : ''}`">
                      {{ hour.title }}
                    </th>
                    <td class="value-hour">{{ hour.value }}</td>
                  </tr>
                </table>
              </div>
            </div>
            <hr />
            <div class="footer-copyright">
              <div class="responsive-mobile">
                <span class="text-copyrigth">
                  &copy; Copyright 2021
                  <a href="https://space.monresto.menu" class="link"
                    >Monresto.menu</a
                  ></span
                >
                <img
                  class="logo-bottom-footer"
                  src="https://space.monresto.menu/icons/Logo@2x.png"
                  alt=""
                />
              </div>
              <div class="social-icons-custom">
                <a
                  :href="
                    `${restaurant.reseau ? restaurant.reseau.facebook : ''}`
                  "
                  class="icon-social-custom facebook"
                  ><i class="fab fa-facebook-f "></i
                ></a>
                <a
                  :href="
                    `${restaurant.reseau ? restaurant.reseau.instagram : ''}`
                  "
                  class="icon-social-custom instagram"
                  ><i class="fab fa-instagram  "></i
                ></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  props: ["restaurant", "smaler", "currentLang"],

  data() {
    return {
      name: "amine",
    };
  },
  methods: {},
  watch: {},
};
</script>
<style>
a.icon-social-custom {
  font-size: 18px;
  width: 27px !important;
  height: 27px !important;
  background: aliceblue;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  color: white;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  margin: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.logo-bottom-footer {
  width: 150px;
  position: relative;
  right: 35px;
}
.text-info {
  max-width: 257px;
  color: black;
  font-size: 12px;
}
.footer-infos {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 20px 25px 0px 25px;
}
.footer-copyright {
  background: black;

  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  /* flex-direction: column; */
}
.icon-social {
  font-size: 18px;
  width: 27px !important;
  height: 27px !important;
  background: aliceblue;
  display: flex;
  color: white;
  align-items: center;
  justify-content: center;
  margin: 5px;
}
a.icon-social {
  color: white;
}

a.icon-social-custom.facebook {
  background: #1877f2;
}
a.icon-social-custom.instagram {
  background: #fd45a1;
}
/*  */
.container-footer {
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.footer-logo {
  width: 90px;
  height: auto;
  margin-bottom: 1em;
}
footer {
  background: #ededed;
  color: #ccc;
  /* padding: 80px 0 80px 0; */
}

footer h3,
.de_light footer h3 {
  color: #fff;
  font-size: 20px;
  text-transform: none;
  font-weight: normal;
}

footer a {
  color: black;
}

footer a:visited {
  color: white;
}

footer a:hover {
  color: #17a2b8 !important;
}
.-cstom {
  display: flex;
}
.-cstom i {
  text-shadow: none;
  color: rgb(255, 255, 255);
  padding: 8px;
  width: 50px;
  height: 50px;
  text-align: center;
  font-size: 16px;
  border-radius: 1px;
  -moz-border-radius: 1px;
  -webkit-border-radius: 1px;
}
.-cstom i:hover {
  background: #fff;
  border-color: #eceff3;
  color: rgb(255, 255, 255);
}
.copyright-footer {
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

#hours {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  /* width: 100%; */
  min-width: 200px;
}

#hours td,
#hours th {
  border: 1px solid rgb(255, 255, 255);
  padding: 8px;
}

#hours tr:nth-child(even) {
  background-color: #f2f2f2;
}

#hours tr:hover {
  /* background-color: #ddd; */
}

#hours th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #fff;
  color: black;
}
.link {
  color: white !important;
}
.link:hover {
  text-decoration: underline;
}
.text-copyrigth {
  margin-left: 1em;

  color: white;
}
.list-infos {
  padding: 0;
  list-style: none;
  text-align: left;
}
.item-info {
  padding: 5px;
}
.icon-info {
  margin-right: 15px;
}
.title-info {
  color: black;
  font-weight: 700;
  margin-bottom: 2em;
}
.value-hour {
  color: black;
}
.colored-tr {
  background-color: #ededed !important;
}
.social-icons-custom {
  display: flex;
}
.responsive-mobile {
  flex: 1;
  text-align: left;
}
.logo-bottom-footer {
  position: relative;
  left: 344px;
}
.container-content,
.container-footer {
  max-width: unset !important;
  padding: 0 !important;
}
@media screen and (max-width: 580px) {
  .container-body-footer {
    width: 100%;
    margin: 0;
    padding: 0;
  }
  .footer-infos {
    flex-direction: column;
  }
  .logo-bottom-footer {
    position: relative;
    right: 14px !important;
    width: 90px;
    height: auto;
    object-fit: contain;
    left: 0;
  }
  .footer-copyright {
    flex-direction: row;
    justify-content: center;
  }
  .text-copyrigth {
    margin: 0 !important;
    font-size: 8px;
    position: relative;
    right: 20px;
  }
  /* .icon-social-custom i {
    font-size: 12px;
  } */
  a.icon-social-custom {
    font-size: 12px !important;
    width: 19px !important;
    height: 19px !important;
  }
  .responsive-mobile {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-around;
    flex: 4;
  }
  .social-icons-custom {
    flex: 1;
  }
  html {
    width: 100%;
  }
}
</style>
